import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetReportStagesFromByReportId = createAsyncThunk(
  "dropdowns/GetReportStagesFromByReportId",
  async (reportId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `/api/DropDowns/GetReportStagesFromByReportId?reportId=${reportId}`
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetReportStagesToByReportId = createAsyncThunk(
  "dropdowns/GetReportStagesToByReportId",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `/api/DropDowns/GetReportStagesToByReportId?reportId=${model.reportId}&currentStage=${model.currentStage}`
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetPR_ItemType = createAsyncThunk(
  "dropdowns/GetPR_ItemType",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(`/api/DropDowns/GetPR_ItemType`);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllItems = createAsyncThunk(
  "dropdowns/GetAllItems",
  async (model, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        `/api/DropDowns/GetAllItems?type=${model.type}`,
        {
          aI_ApplicationInformationId: model.aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const TransferDropDowns = createSlice({
  name: "TransferDropDowns",
  initialState: {
    //-------------------------- ReportStagesDropDown FROM -------------------------
    ReportStagesDropDownFrom: [],
    loadingReportStagesDropDownFrom: false,
    errorReportStagesDropDownFrom: null,
    //-------------------------- ReportStagesDropDown  TO-------------------------
    ReportStagesDropDownTo: [],
    loadingReportStagesDropDownTo: false,
    errorReportStagesDropDownTo: null,
    //--------------------------   GetPR_ItemType -------------------------
    PR_ItemTypeList: [],
    loadingPR_ItemTypeList: false,
    errorPR_ItemTypeList: null,
    //--------------------------   GetAllItems -------------------------
    AllItemsList: [],
    loadingAllItemsList: false,
    errorAllItemsList: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    //-------------------------- ReportStagesDropDown FROM -------------------------

    builder
      .addCase(GetReportStagesFromByReportId.pending, (state, action) => {
        state.loadingReportStagesDropDownFrom = true;
        state.ReportStagesDropDownFrom = action.payload;
        state.errorReportStagesDropDownFrom = null;
      })
      .addCase(GetReportStagesFromByReportId.fulfilled, (state, action) => {
        state.loadingReportStagesDropDownFrom = false;
        state.ReportStagesDropDownFrom = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetReportStagesFromByReportId.rejected, (state, action) => {
        state.loadingReportStagesDropDownFrom = false;
        state.errorReportStagesDropDownFrom = action.payload;
      });
    //-------------------------- ReportStagesDropDown  TO-------------------------

    builder
      .addCase(GetReportStagesToByReportId.pending, (state, action) => {
        state.loadingReportStagesDropDownTo = true;
        state.ReportStagesDropDownTo = action.payload;
        state.errorReportStagesDropDownTo = null;
      })
      .addCase(GetReportStagesToByReportId.fulfilled, (state, action) => {
        state.loadingReportStagesDropDownTo = false;
        state.ReportStagesDropDownTo = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetReportStagesToByReportId.rejected, (state, action) => {
        state.loadingReportStagesDropDownTo = false;
        state.errorReportStagesDropDownTo = action.payload;
      });
    //--------------------------   GetPR_ItemType -------------------------
    builder
      .addCase(GetPR_ItemType.pending, (state, action) => {
        state.loadingPR_ItemTypeList = true;
        state.PR_ItemTypeList = action.payload;
        state.errorPR_ItemTypeList = null;
      })
      .addCase(GetPR_ItemType.fulfilled, (state, action) => {
        state.loadingPR_ItemTypeList = false;
        state.PR_ItemTypeList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetPR_ItemType.rejected, (state, action) => {
        state.loadingPR_ItemTypeList = false;
        state.errorPR_ItemTypeList = action.payload;
      });
    //--------------------------   GetAllItems -------------------------
    builder
      .addCase(GetAllItems.pending, (state, action) => {
        state.loadingAllItemsList = true;
        state.AllItemsList = action.payload;
        state.errorAllItemsList = null;
      })
      .addCase(GetAllItems.fulfilled, (state, action) => {
        state.loadingAllItemsList = false;
        state.AllItemsList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllItems.rejected, (state, action) => {
        state.loadingAllItemsList = false;
        state.errorAllItemsList = action.payload;
      });
  },
});

export default TransferDropDowns.reducer;
